
let _displayNameElement = null;
let _messageElement = null;
let _subDomainElement = null;

let _displayName = "";
let _email = "";
let _subDomain = "";

Office.initialize = function(reason)
{
  onInitializationComplete();
}

function onInitializationComplete()
{
	$(document).ready
	(
		function()
		{
      document.getElementById("saveDomain").onclick = saveDomain;
      document.getElementById("updateSignature").onclick = updateSignature;

      _displayNameElement = $("#displayName");
      _messageElement = $("#message");
      _subDomainElement = $("#subDomain");
      
      console.log("onInitializationComplete displayNameElement", _displayNameElement);
      console.log("onInitializationComplete messageElement", _messageElement);

      prepopulateFromUserProfile();
      loadSavedUserInfo();
		}
	);
}

function prepopulateFromUserProfile()
{
  _displayName = Office.context.mailbox.userProfile.displayName;
  _email = Office.context.mailbox.userProfile.emailAddress;
  _subDomain = Office.context.roamingSettings.get("subDomain");

  if (_subDomain.trim() === "") {
    displayMessage("Please configure your Rocketseed server to enable signatures.", "warning");
  }

  console.log("prepopulateFromUserProfile displayName", _displayName);
  console.log("prepopulateFromUserProfile email", _email);
  console.log("prepopulateFromUserProfile domain", _subDomain);
}

function loadSavedUserInfo()
{
  _displayNameElement.html(_displayName);
  _subDomainElement.val(_subDomain);
}

function displayMessage(msg, type)
{
  clearMessage();

  _messageElement.html(msg);
  _messageElement.addClass("alert-" + type);
  _messageElement.removeClass("d-none");
}

function clearMessage()
{
  _messageElement.removeClass("alert-warning");
  _messageElement.removeClass("alert-success");
  _messageElement.removeClass("alert-danger");
  _messageElement.addClass("d-none");
  _messageElement.html("");
}

function displayAndFadeOutMessage(msg, type) {
  displayMessage(msg, type);

  setTimeout(function() {
    clearMessage();
  }, 2000);
}

function saveDomain()
{
  _subDomain = _subDomainElement.val();
  Office.context.roamingSettings.set("subDomain", _subDomain);

  Office.context.roamingSettings.saveAsync(function(result) {
    if (result.status !== Office.AsyncResultStatus.Succeeded) {
      console.error("Action failed with message" + result.error.message);
      displayMessage("Error saving settings. Please contact Rocketseed support.", "warning");
    } else {
      console.log("Settings saved with status:" + result.status);
      displayAndFadeOutMessage("Saved sucessfully", "success");
    }
  });
}

function updateSignature() {
  try {
    if (_subDomain.trim() === "" || _email.trim() === "") {
      displayMessage("Please configure your Rocketseed server before updating your signature.", "warning");
    }
    else {
      let url = "https://" + _subDomain + ".rocketseed.com/rscommon/json/signature?sender=" + _email;

      let xhr = new XMLHttpRequest();
      xhr.open('GET', url);
      xhr.send();

      xhr.onload = function() {
        if (xhr.status != 200) { // analyze HTTP status of the response
          displayMessage("Error contacting server. Please contact Rocketseed suporrt.");
        } else { // show the result
          let data = JSON.parse(xhr.response);
          
          if (data && data.html && (data.html.trim() !== "")) {
            console.log("fetching data success", _email, data);
            setSignatureHtml(data, setCustomHeaders);
          } else {
            console.log("fetching data error ", data);
            displayMessage("No signature assigned to: " + _email + ". Please make sure your Rocketseed configuration is correct.");
          }
        }
      };

      xhr.onerror = function() {
        displayMessage("Error contacting server. Please contact Rocketseed suporrt.");
      };
    }
  } catch (error) {
    displayMessage("Error contacting server. Please contact Rocketseed suporrt.");
  }
}

function setCustomHeaders(mailId) {
  Office.context.mailbox.item.internetHeaders.setAsync(
    { "X-Rocketseed-Mailid": mailId },
    function (asyncResult) { 
        if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
          console.log("Successfully set headers");
        } else {
          console.log("Error setting headers: " + JSON.stringify(asyncResult.error));
        }
    }
  );
}

function setSignatureHtml(data, callback) {
  let signature = data.html;
  let mailId = data.mailid;

  if (signature.trim() === "") {
    displayMessage("No signature is assigned to the sender. Please make sure the sender has a signature assigned and try again. If this error persists please contact Rocketseed support", "danger");
    return false;
  } else {
    Office.context.mailbox.item.body.setSignatureAsync(
      signature,
      {
        coercionType: Office.CoercionType.Html,
        asyncContext: { signature: signature, mailId: mailId, callback: callback }
      },
      function (asyncResult) {
        if (asyncResult.status == Office.AsyncResultStatus.Succeeded) {
          asyncResult.asyncContext.callback(asyncResult.asyncContext.mailId);
        } else {
          // This means setSignatureAsync isn't supported on the client (usually Outlook on Mac)
          // So we try and set the signature to the body content
          Office.context.mailbox.item.body.setAsync(asyncResult.asyncContext.signature,
            { 
              coercionType: Office.CoercionType.Html,
              asyncContext: { signature: asyncResult.asyncContext.signature, mailId: asyncResult.asyncContext.mailId, callback: asyncResult.asyncContext.callback }
            },
            function (asyncResult) { 
              console.log("Set body asyncresult", asyncResult);

              if (asyncResult.status == Office.AsyncResultStatus.Succeeded) {
                asyncResult.asyncContext.callback(asyncResult.asyncContext.mailId);
              }
              else {
                displayMessage("Failed setting signature. Please contact Rocketseeed support.");
              }
            }
          );
        }
      }
    );  
  }
}

